import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { Icon } from "@qgiv/core-react";
import { TextButton, Divider } from "@qgiv/core-donor";
import "./CurrentRegistrationNav.scss";

const CurrentRegistrationNav = ({
    currentRegistration,
    isMediumScreen,
    enableCancel,
    hasProducts,
    isCms,
    isVisible = true,
    displayName,
    registrations,
    removeRegistration,
    baseUrl,
}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleCancel = () => {
        const registration = registrations[currentRegistration];
        const hasRegistrationBeenSubmitted = registration?.Has_Been_Saved;

        if (!hasRegistrationBeenSubmitted) {
            dispatch(removeRegistration(currentRegistration));
        }

        const urlToNavigateTo = `${baseUrl}/form/${hasProducts ? "store" : "payment"}`;
        navigate(urlToNavigateTo);
    };

    return (
        isVisible && (
            <div
                className={`current-registration-nav ${
                    !isMediumScreen ? "current-registration-nav__padding" : ""
                }`}
            >
                {isMediumScreen && (
                    <Divider classNames="current-registration-nav__divider -display--block" />
                )}

                <nav
                    className={`current-registration-nav__nav ${
                        isMediumScreen ? "-padding--5" : "-padding--10"
                    }`}
                >
                    <ul className="-text--center">
                        <li className="current-registration-nav__li">
                            <div className="current-registration-nav__inline-flex">
                                <Icon
                                    className="current-registration-nav__icon"
                                    glyph="user-solid"
                                    type="FontAwesome"
                                />
                                <small>{displayName}</small>
                                {enableCancel && (
                                    <>
                                        <Icon
                                            className="current-registration-nav__separator"
                                            glyph="circle-solid"
                                            type="FontAwesome"
                                        />

                                        {isCms ? (
                                            <TextButton>
                                                <small>Cancel</small>
                                            </TextButton>
                                        ) : (
                                            <TextButton
                                                handleClick={handleCancel}
                                            >
                                                <strong>
                                                    <small>Cancel</small>
                                                </strong>
                                            </TextButton>
                                        )}
                                    </>
                                )}
                            </div>
                        </li>
                    </ul>
                </nav>
                {!isMediumScreen && (
                    <Divider classNames="current-registration-nav__divider -display--block" />
                )}
            </div>
        )
    );
};

CurrentRegistrationNav.propTypes = {
    // Flag for toggling divider
    isMediumScreen: PropTypes.bool.isRequired,
    // Combination of first and last name, will be empty string is missing either
    displayName: PropTypes.string.isRequired,
    // Flag telling us to display the cancel button
    enableCancel: PropTypes.bool.isRequired,
    // Flag telling us the should be a store page
    hasProducts: PropTypes.bool.isRequired,
    // Flag telling us that component is rendered in CMS
    isCms: PropTypes.bool.isRequired,
    // Flag telling us that component should be visible
    isVisible: PropTypes.bool.isRequired,
    // active index of registrations
    currentRegistration: PropTypes.number.isRequired,
    // array of stateful registrations
    registrations: PropTypes.arrayOf(
        PropTypes.shape({ Has_Been_Saved: PropTypes.bool }),
    ).isRequired,
    // redux action to remove registration from registrations array and reset currentRegistration
    removeRegistration: PropTypes.func.isRequired,
    baseUrl: PropTypes.string.isRequired,
};

export default CurrentRegistrationNav;
